import { apiInstance } from '../helpers';
import { apiFormInstance } from '../helpers';


export const CONSENT_HALIFAX_URL_NAME = 'halifax';
export const CONSENT_PEI_URL_NAME = 'pei';


function create(params, dateOfBirth='', signature='', witnessSignature='', investigatorSignature='', consentFile='') {

    if (dateOfBirth !== '') {
        params.dateOfBirth = dateOfBirth;
    }

    if (signature !== '') {
        params.signature = signature;
    }

    if (witnessSignature !== '') {
        params.witnessSignature = witnessSignature;
    }

    if (investigatorSignature !== '') {
        params.investigatorSignature = investigatorSignature;
    }

    if (consentFile !== '') {
       params.consentFile = consentFile;
       let formData = new FormData();

       Object.keys(params).map((key) => {
               if (params[key]){
                 formData.append(key, params[key])
               }
             });

       formData.append('consentFile', params.consentFile[0].originFileObj);

       return apiFormInstance.post('/consent', formData)
            .then(response => {
                return response
            })
            .catch(error => {
                return Promise.reject(error);
            });

    } else {

        return apiInstance.post('/consent', params)
            .then(response => {
                return response
            })
            .catch(error => {
                return Promise.reject(error);
            });

    }
}

const createCalgaryLikeConsentByUrl = url => (params, dateOfBirth='', signature='', witnessSignature='', investigatorSignature='', consentFile='') => {

  if (dateOfBirth !== '') {
    params.dateOfBirth = dateOfBirth;
  }

  if (signature !== '') {
    params.signature = signature;
  }

  if (witnessSignature !== '') {
    params.witnessSignature = witnessSignature;
  }

  if (investigatorSignature !== '') {
    params.investigatorSignature = investigatorSignature;
  }

  if (consentFile !== '') {
    params.consentFile = consentFile;
    let formData = new FormData();

    Object.keys(params).map((key) => {
      if (params[key]){
        formData.append(key, params[key])
      }
    });

    formData.append('consentFile', params.consentFile[0].originFileObj);

    return apiFormInstance.post(url, formData)
      .then(response => {
        return response
      })
      .catch(error => {
        return Promise.reject(error);
      });

  } else {

    return apiInstance.post(url, params)
      .then(response => {
        return response
      })
      .catch(error => {
        return Promise.reject(error);
      });

  }
}


function createEdmonton(params, consentFile='', consentFileDc=null, consentFileWithdraw=null) {
    if (consentFile !== '' || consentFileDc !== null || consentFileWithdraw !== null) {
       params.consentFile = consentFile;
       if (consentFileDc !== null) {
         params.consentFileDc = consentFileDc;
       }
       if ( consentFileWithdraw !== null) {
         params.consentFileWithdraw = consentFileWithdraw;
       }

       let formData = new FormData();

       Object.keys(params).map((key) => {
          if (params[key] && !['consentFile', 'consentFileDc', 'consentFileWithdraw', 'fileList', 'fileListDc', 'fileListWithdraw'].includes(key)){
            formData.append(key, params[key])
          }
        });

       formData.append('consentFile', params.consentFile[0].originFileObj);
       if (consentFileDc !== null) {
         formData.append('consentFileDc', params.consentFileDc[0].originFileObj);
       }
       if ( consentFileWithdraw !== null) {
         formData.append('consentFileWithdraw', params.consentFileWithdraw[0].originFileObj);
       }

       return apiFormInstance.post('/consent/workflow/edmonton', formData)
            .then(response => {
                return response
            })
            .catch(error => {
                return Promise.reject(error);
            });

    } else {

        return apiInstance.post('/consent/workflow/edmonton', params)
            .then(response => {
                return response
            })
            .catch(error => {
                return Promise.reject(error);
            });

    }
}


function createMedicineHat(params, consentFile='', consentFileDc=null, consentFileWithdraw=null) {
    if (consentFile !== '' || consentFileDc !== null || consentFileWithdraw !== null) {
       params.consentFile = consentFile;
       if (consentFileDc !== null) {
         params.consentFileDc = consentFileDc;
       }
       if ( consentFileWithdraw !== null) {
         params.consentFileWithdraw = consentFileWithdraw;
       }

       let formData = new FormData();

       Object.keys(params).map((key) => {
          if (params[key] && !['consentFile', 'consentFileDc', 'consentFileWithdraw', 'fileList', 'fileListDc', 'fileListWithdraw'].includes(key)){
            formData.append(key, params[key])
          }
        });

       formData.append('consentFile', params.consentFile[0].originFileObj);
       if (consentFileDc !== null) {
         formData.append('consentFileDc', params.consentFileDc[0].originFileObj);
       }
       if ( consentFileWithdraw !== null) {
         formData.append('consentFileWithdraw', params.consentFileWithdraw[0].originFileObj);
       }

       return apiFormInstance.post('/consent/workflow/medicine_hat', formData)
            .then(response => {
                return response
            })
            .catch(error => {
                return Promise.reject(error);
            });

    } else {

        return apiInstance.post('/consent/workflow/medicine_hat', params)
            .then(response => {
                return response
            })
            .catch(error => {
                return Promise.reject(error);
            });

    }
}


function createGreyNuns(params, consentFile='', consentFileDc=null, consentFileWithdraw=null) {
    if (consentFile !== '' || consentFileDc !== null || consentFileWithdraw !== null) {
       params.consentFile = consentFile;
       if (consentFileDc !== null) {
         params.consentFileDc = consentFileDc;
       }
       if ( consentFileWithdraw !== null) {
         params.consentFileWithdraw = consentFileWithdraw;
       }

       let formData = new FormData();

       Object.keys(params).map((key) => {
          if (params[key] && !['consentFile', 'consentFileDc', 'consentFileWithdraw', 'fileList', 'fileListDc', 'fileListWithdraw'].includes(key)){
            formData.append(key, params[key])
          }
        });

       formData.append('consentFile', params.consentFile[0].originFileObj);
       if (consentFileDc !== null) {
         formData.append('consentFileDc', params.consentFileDc[0].originFileObj);
       }
       if ( consentFileWithdraw !== null) {
         formData.append('consentFileWithdraw', params.consentFileWithdraw[0].originFileObj);
       }

       return apiFormInstance.post('/consent/workflow/grey_nuns', formData)
            .then(response => {
                return response
            })
            .catch(error => {
                return Promise.reject(error);
            });

    } else {

        return apiInstance.post('/consent/workflow/grey_nuns', params)
            .then(response => {
                return response
            })
            .catch(error => {
                return Promise.reject(error);
            });

    }
}


const getConsentGreyNunsByToken = token => apiInstance.get(`/consent/workflow/grey_nuns/${token}`)
  .then(response => {
    return response
  })
  .catch(error => {
    return Promise.reject(error);
  });


const confirmConsentGreyNunsByToken = (token, params, dateOfBirth='', signature='', witnessSignature='', investigatorSignature='', consentFile='') => {

  if (dateOfBirth !== '') {
    params.dateOfBirth = dateOfBirth;
  }

  if (signature !== '') {
    params.signature = signature;
  }

  if (witnessSignature !== '') {
    params.witnessSignature = witnessSignature;
  }

  if (investigatorSignature !== '') {
    params.investigatorSignature = investigatorSignature;
  }

  return apiInstance.post(`/consent/workflow/grey_nuns/${token}/confirm`, params)
    .then(response => {
      return response
    })
    .catch(error => {
      return Promise.reject(error);
    });
}


function createSunnyBrook(params, consentFile='', consentFileDc=null, consentFileWithdraw=null) {
    if (consentFile !== '' || consentFileDc !== null || consentFileWithdraw !== null) {
       params.consentFile = consentFile;
       if (consentFileDc !== null) {
         params.consentFileDc = consentFileDc;
       }
       if ( consentFileWithdraw !== null) {
         params.consentFileWithdraw = consentFileWithdraw;
       }

       let formData = new FormData();

       Object.keys(params).map((key) => {
          if (params[key] && !['consentFile', 'consentFileDc', 'consentFileWithdraw', 'fileList', 'fileListDc', 'fileListWithdraw'].includes(key)){
            formData.append(key, params[key])
          }
        });

       formData.append('consentFile', params.consentFile[0].originFileObj);
       if (consentFileDc !== null) {
         formData.append('consentFileDc', params.consentFileDc[0].originFileObj);
       }
       if ( consentFileWithdraw !== null) {
         formData.append('consentFileWithdraw', params.consentFileWithdraw[0].originFileObj);
       }

       return apiFormInstance.post('/consent/workflow/sunnybrook', formData)
            .then(response => {
                return response
            })
            .catch(error => {
                return Promise.reject(error);
            });

    } else {

        return apiInstance.post('/consent/workflow/sunnybrook', params)
            .then(response => {
                return response
            })
            .catch(error => {
                return Promise.reject(error);
            });

    }
}

function createTorontoUH(params, consentFile='', consentFileDc=null, consentFileWithdraw=null) {
    if (consentFile !== '' || consentFileDc !== null || consentFileWithdraw !== null) {
       params.consentFile = consentFile;
       if (consentFileDc !== null) {
         params.consentFileDc = consentFileDc;
       }
       if ( consentFileWithdraw !== null) {
         params.consentFileWithdraw = consentFileWithdraw;
       }

       let formData = new FormData();

       Object.keys(params).map((key) => {
          if (params[key] && !['consentFile', 'consentFileDc', 'consentFileWithdraw', 'fileList', 'fileListDc', 'fileListWithdraw'].includes(key)){
            formData.append(key, params[key])
          }
        });

       formData.append('consentFile', params.consentFile[0].originFileObj);
       if (consentFileDc !== null) {
         formData.append('consentFileDc', params.consentFileDc[0].originFileObj);
       }
       if ( consentFileWithdraw !== null) {
         formData.append('consentFileWithdraw', params.consentFileWithdraw[0].originFileObj);
       }

       return apiFormInstance.post('/consent/workflow/toronto_uh', formData)
            .then(response => {
                return response
            })
            .catch(error => {
                return Promise.reject(error);
            });

    } else {

        return apiInstance.post('/consent/workflow/toronto_uh', params)
            .then(response => {
                return response
            })
            .catch(error => {
                return Promise.reject(error);
            });

    }
}

function createOttawa(params, consentFile='', consentFileDc=null, consentFileWithdraw=null) {
    if (consentFile !== '' || consentFileDc !== null || consentFileWithdraw !== null) {
       params.consentFile = consentFile;
       if (consentFileDc !== null) {
         params.consentFileDc = consentFileDc;
       }
       if ( consentFileWithdraw !== null) {
         params.consentFileWithdraw = consentFileWithdraw;
       }

       let formData = new FormData();

       Object.keys(params).map((key) => {
          if (params[key] && !['consentFile', 'consentFileDc', 'consentFileWithdraw', 'fileList', 'fileListDc', 'fileListWithdraw'].includes(key)){
            formData.append(key, params[key])
          }
        });

       formData.append('consentFile', params.consentFile[0].originFileObj);
       if (consentFileDc !== null) {
         formData.append('consentFileDc', params.consentFileDc[0].originFileObj);
       }
       if ( consentFileWithdraw !== null) {
         formData.append('consentFileWithdraw', params.consentFileWithdraw[0].originFileObj);
       }

       return apiFormInstance.post('/consent/workflow/ottawa', formData)
            .then(response => {
                return response
            })
            .catch(error => {
                return Promise.reject(error);
            });

    } else {

        return apiInstance.post('/consent/workflow/ottawa', params)
            .then(response => {
                return response
            })
            .catch(error => {
                return Promise.reject(error);
            });

    }
}

function createRoyal(params, consentFile='', consentFileDc=null, consentFileWithdraw=null) {
  if (consentFile !== '' || consentFileDc !== null || consentFileWithdraw !== null) {
    params.consentFile = consentFile;
    if (consentFileDc !== null) {
      params.consentFileDc = consentFileDc;
    }
    if ( consentFileWithdraw !== null) {
      params.consentFileWithdraw = consentFileWithdraw;
    }

    let formData = new FormData();

    Object.keys(params).map((key) => {
      if (params[key] && !['consentFile', 'consentFileDc', 'consentFileWithdraw', 'fileList', 'fileListDc', 'fileListWithdraw'].includes(key)){
        formData.append(key, params[key])
      }
    });

    formData.append('consentFile', params.consentFile[0].originFileObj);
    if (consentFileDc !== null) {
      formData.append('consentFileDc', params.consentFileDc[0].originFileObj);
    }
    if ( consentFileWithdraw !== null) {
      formData.append('consentFileWithdraw', params.consentFileWithdraw[0].originFileObj);
    }

    return apiFormInstance.post('/consent/workflow/royal', formData)
      .then(response => {
        return response
      })
      .catch(error => {
        return Promise.reject(error);
      });

  } else {

    return apiInstance.post('/consent/workflow/royal', params)
      .then(response => {
        return response
      })
      .catch(error => {
        return Promise.reject(error);
      });

  }
}

function createRoyalUniversity(params, consentFile='', consentFileDc=null, consentFileWithdraw=null) {
    if (consentFile !== '' || consentFileDc !== null || consentFileWithdraw !== null) {
       params.consentFile = consentFile;
       if (consentFileDc !== null) {
         params.consentFileDc = consentFileDc;
       }
       if ( consentFileWithdraw !== null) {
         params.consentFileWithdraw = consentFileWithdraw;
       }

       let formData = new FormData();

       Object.keys(params).map((key) => {
          if (params[key] && !['consentFile', 'consentFileDc', 'consentFileWithdraw', 'fileList', 'fileListDc', 'fileListWithdraw'].includes(key)){
            formData.append(key, params[key])
          }
        });

       formData.append('consentFile', params.consentFile[0].originFileObj);
       if (consentFileDc !== null) {
         formData.append('consentFileDc', params.consentFileDc[0].originFileObj);
       }
       if ( consentFileWithdraw !== null) {
         formData.append('consentFileWithdraw', params.consentFileWithdraw[0].originFileObj);
       }

       return apiFormInstance.post('/consent/workflow/royal_university', formData)
            .then(response => {
                return response
            })
            .catch(error => {
                return Promise.reject(error);
            });

    } else {

        return apiInstance.post('/consent/workflow/royal_university', params)
            .then(response => {
                return response
            })
            .catch(error => {
                return Promise.reject(error);
            });

    }
}

function createWinnipeg(params, consentFile='') {
  if (consentFile !== '') {
     params.consentFile = consentFile;

     let formData = new FormData();

     Object.keys(params).map((key) => {
        if (params[key] && !['consentFile', 'fileList'].includes(key)){
          formData.append(key, params[key])
        }
      });

     formData.append('consentFile', params.consentFile[0].originFileObj);

     return apiFormInstance.post('/consent/workflow/winnipeg', formData)
          .then(response => {
              return response
          })
          .catch(error => {
              return Promise.reject(error);
          });

  } else {

      return apiInstance.post('/consent/workflow/winnipeg', params)
          .then(response => {
              return response
          })
          .catch(error => {
              return Promise.reject(error);
          });

  }
}

function createUhn(params, consentFile='') {
  if (consentFile !== '') {
     params.consentFile = consentFile;

     let formData = new FormData();

     Object.keys(params).map((key) => {
        if (params[key] && !['consentFile', 'fileList'].includes(key)){
          formData.append(key, params[key])
        }
      });

     formData.append('consentFile', params.consentFile[0].originFileObj);

     return apiFormInstance.post('/consent/workflow/uhn', formData)
          .then(response => {
              return response
          })
          .catch(error => {
              return Promise.reject(error);
          });

  } else {

      return apiInstance.post('/consent/workflow/uhn', params)
          .then(response => {
              return response
          })
          .catch(error => {
              return Promise.reject(error);
          });

  }
}

function createMontreal(params, consentFile='') {
  if (consentFile !== '') {
     params.consentFile = consentFile;

     let formData = new FormData();

     Object.keys(params).map((key) => {
        if (params[key] && !['consentFile', 'fileList'].includes(key)){
          formData.append(key, params[key])
        }
      });

     formData.append('consentFile', params.consentFile[0].originFileObj);

     return apiFormInstance.post('/consent/workflow/montreal', formData)
          .then(response => {
              return response
          })
          .catch(error => {
              return Promise.reject(error);
          });

  } else {

      return apiInstance.post('/consent/workflow/montreal', params)
          .then(response => {
              return response
          })
          .catch(error => {
              return Promise.reject(error);
          });

  }
}


function createVancouver(params, consentFile='') {
  if (consentFile !== '') {
     params.consentFile = consentFile;

     let formData = new FormData();

     Object.keys(params).map((key) => {
        if (params[key] && !['consentFile', 'fileList'].includes(key)){
          formData.append(key, params[key])
        }
      });

     formData.append('consentFile', params.consentFile[0].originFileObj);

     return apiFormInstance.post('/consent/workflow/vancouver', formData)
          .then(response => {
              return response
          })
          .catch(error => {
              return Promise.reject(error);
          });

  } else {

      return apiInstance.post('/consent/workflow/vancouver', params)
          .then(response => {
              return response
          })
          .catch(error => {
              return Promise.reject(error);
          });

  }
}

function createChus(params, consentFile='') {
  if (consentFile !== '') {
     params.consentFile = consentFile;

     let formData = new FormData();

     Object.keys(params).map((key) => {
        if (params[key] && !['consentFile', 'fileList'].includes(key)){
          formData.append(key, params[key])
        }
      });

     formData.append('consentFile', params.consentFile[0].originFileObj);

     return apiFormInstance.post('/consent/workflow/chus', formData)
          .then(response => {
              return response
          })
          .catch(error => {
              return Promise.reject(error);
          });

  } else {

      return apiInstance.post('/consent/workflow/chus', params)
          .then(response => {
              return response
          })
          .catch(error => {
              return Promise.reject(error);
          });

  }
}

function createQuebecChu(params, consentFile='') {
  if (consentFile !== '') {
     params.consentFile = consentFile;

     let formData = new FormData();

     Object.keys(params).map((key) => {
        if (params[key] && !['consentFile', 'fileList'].includes(key)){
          formData.append(key, params[key])
        }
      });

     formData.append('consentFile', params.consentFile[0].originFileObj);

     return apiFormInstance.post('/consent/workflow/quebec_chu', formData)
          .then(response => {
              return response
          })
          .catch(error => {
              return Promise.reject(error);
          });

  } else {

      return apiInstance.post('/consent/workflow/quebec_chu', params)
          .then(response => {
              return response
          })
          .catch(error => {
              return Promise.reject(error);
          });

  }
}


function createConsentByType(workflow_type, params, consentFile='') {
  if (consentFile !== '') {
     params.consentFile = consentFile;

     let formData = new FormData();

     Object.keys(params).map((key) => {
        if (params[key] && !['consentFile', 'fileList'].includes(key)){
          formData.append(key, params[key])
        }
      });

     formData.append('consentFile', params.consentFile[0].originFileObj);

     return apiFormInstance.post(`/consent/workflow/${workflow_type}`, formData)
          .then(response => {
              return response
          })
          .catch(error => {
              return Promise.reject(error);
          });

  } else {

      return apiInstance.post(`/consent/workflow/${workflow_type}`, params)
          .then(response => {
              return response
          })
          .catch(error => {
              return Promise.reject(error);
          });

  }
}

function createKelowna(params, consentFile='', consentFileDc=null, consentFileWithdraw=null) {
    if (consentFile !== '' || consentFileDc !== null || consentFileWithdraw !== null) {
       params.consentFile = consentFile;
       if (consentFileDc !== null) {
         params.consentFileDc = consentFileDc;
       }
       if ( consentFileWithdraw !== null) {
         params.consentFileWithdraw = consentFileWithdraw;
       }

       let formData = new FormData();

       Object.keys(params).map((key) => {
          if (params[key] && !['consentFile', 'consentFileDc', 'consentFileWithdraw', 'fileList', 'fileListDc', 'fileListWithdraw'].includes(key)){
            formData.append(key, params[key])
          }
        });

       formData.append('consentFile', params.consentFile[0].originFileObj);
       if (consentFileDc !== null) {
         formData.append('consentFileDc', params.consentFileDc[0].originFileObj);
       }
       if ( consentFileWithdraw !== null) {
         formData.append('consentFileWithdraw', params.consentFileWithdraw[0].originFileObj);
       }

       return apiFormInstance.post('/consent/workflow/kelowna', formData)
            .then(response => {
                return response
            })
            .catch(error => {
                return Promise.reject(error);
            });

    } else {

        return apiInstance.post('/consent/workflow/kelowna', params)
            .then(response => {
                return response
            })
            .catch(error => {
                return Promise.reject(error);
            });

    }
}

const getConsentByToken = token => apiInstance.get(`/consent/${token}`)
  .then(response => {
    return response
  })
  .catch(error => {
    return Promise.reject(error);
  });

const getConsentEdmontonByToken = token => apiInstance.get(`/consent/workflow/edmonton/${token}`)
  .then(response => {
    return response
  })
  .catch(error => {
    return Promise.reject(error);
  });

const getConsentMedicineHatByToken = token => apiInstance.get(`/consent/workflow/medicine_hat/${token}`)
  .then(response => {
    return response
  })
  .catch(error => {
    return Promise.reject(error);
  });

const getConsentSunnyBrookByToken = token => apiInstance.get(`/consent/workflow/sunnybrook/${token}`)
  .then(response => {
    return response
  })
  .catch(error => {
    return Promise.reject(error);
  });

const getConsentTorontoUHByToken = token => apiInstance.get(`/consent/workflow/toronto_uh/${token}`)
  .then(response => {
    return response
  })
  .catch(error => {
    return Promise.reject(error);
  });

const getConsentOttawaByToken = token => apiInstance.get(`/consent/workflow/ottawa/${token}`)
  .then(response => {
    return response
  })
  .catch(error => {
    return Promise.reject(error);
  });

const getConsentRoyalByToken = token => apiInstance.get(`/consent/workflow/royal/${token}`)
  .then(response => {
    return response
  })
  .catch(error => {
    return Promise.reject(error);
  });

const getConsentRoyalUniversityByToken = token => apiInstance.get(`/consent/workflow/royal_university/${token}`)
  .then(response => {
    return response
  })
  .catch(error => {
    return Promise.reject(error);
  });

const getConsentUhnByToken = token => apiInstance.get(`/consent/workflow/sunnybrook/${token}`)
  .then(response => {
    return response
  })
  .catch(error => {
    return Promise.reject(error);
  });

const getConsentByWorkflowTypeAndToken = (workflow_type, token) => apiInstance.get(`/consent/workflow/${workflow_type}/${token}`)
  .then(response => {
    return response
  })
  .catch(error => {
    return Promise.reject(error);
  });

const getConsentWinnipegByToken = token => apiInstance.get(`/consent/workflow/winnipeg/${token}`)
  .then(response => {
    return response
  })
  .catch(error => {
    return Promise.reject(error);
  });

const getConsentMontrealByToken = token => apiInstance.get(`/consent/workflow/montreal/${token}`)
  .then(response => {
    return response
  })
  .catch(error => {
    return Promise.reject(error);
  });

const getConsentVancouverByToken = token => apiInstance.get(`/consent/workflow/vancouver/${token}`)
  .then(response => {
    return response
  })
  .catch(error => {
    return Promise.reject(error);
  });

const getConsentChusByToken = token => apiInstance.get(`/consent/workflow/chus/${token}`)
  .then(response => {
    return response
  })
  .catch(error => {
    return Promise.reject(error);
  });

const getConsentQuebecChuByToken = token => apiInstance.get(`/consent/workflow/quebec_chu/${token}`)
  .then(response => {
    return response
  })
  .catch(error => {
    return Promise.reject(error);
  });

const getConsentKelownaByToken = token => apiInstance.get(`/consent/workflow/kelowna/${token}`)
  .then(response => {
    return response
  })
  .catch(error => {
    return Promise.reject(error);
  });

const confirmConsentByToken = (token, params, dateOfBirth='', signature='', witnessSignature='', investigatorSignature='', consentFile='') => {

  if (dateOfBirth !== '') {
    params.dateOfBirth = dateOfBirth;
  }

  if (signature !== '') {
    params.signature = signature;
  }

  if (witnessSignature !== '') {
    params.witnessSignature = witnessSignature;
  }

  if (investigatorSignature !== '') {
    params.investigatorSignature = investigatorSignature;
  }

  return apiInstance.post(`/consent/${token}/confirm`, params)
    .then(response => {
      return response
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

const confirmConsentEdmontonByToken = (token, params, dateOfBirth='', signature='', witnessSignature='', investigatorSignature='', consentFile='') => {

  if (dateOfBirth !== '') {
    params.dateOfBirth = dateOfBirth;
  }

  if (signature !== '') {
    params.signature = signature;
  }

  if (witnessSignature !== '') {
    params.witnessSignature = witnessSignature;
  }

  if (investigatorSignature !== '') {
    params.investigatorSignature = investigatorSignature;
  }

  return apiInstance.post(`/consent/workflow/edmonton/${token}/confirm`, params)
    .then(response => {
      return response
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

const confirmConsentMedicineHatByToken = (token, params, dateOfBirth='', signature='', witnessSignature='', investigatorSignature='', consentFile='') => {

  if (dateOfBirth !== '') {
    params.dateOfBirth = dateOfBirth;
  }

  if (signature !== '') {
    params.signature = signature;
  }

  if (witnessSignature !== '') {
    params.witnessSignature = witnessSignature;
  }

  if (investigatorSignature !== '') {
    params.investigatorSignature = investigatorSignature;
  }

  return apiInstance.post(`/consent/workflow/medicine_hat/${token}/confirm`, params)
    .then(response => {
      return response
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

const confirmConsentSunnyBrookByToken = (token, params, dateOfBirth='', signature='', witnessSignature='', investigatorSignature='', consentFile='') => {

  if (dateOfBirth !== '') {
    params.dateOfBirth = dateOfBirth;
  }

  if (signature !== '') {
    params.signature = signature;
  }

  if (witnessSignature !== '') {
    params.witnessSignature = witnessSignature;
  }

  if (investigatorSignature !== '') {
    params.investigatorSignature = investigatorSignature;
  }

  return apiInstance.post(`/consent/workflow/sunnybrook/${token}/confirm`, params)
    .then(response => {
      return response
    })
    .catch(error => {
      return Promise.reject(error);
    });
}


const confirmConsentTorontoUHByToken = (token, params, dateOfBirth='', signature='', witnessSignature='', investigatorSignature='', consentFile='') => {

  if (dateOfBirth !== '') {
    params.dateOfBirth = dateOfBirth;
  }

  if (signature !== '') {
    params.signature = signature;
  }

  if (witnessSignature !== '') {
    params.witnessSignature = witnessSignature;
  }

  if (investigatorSignature !== '') {
    params.investigatorSignature = investigatorSignature;
  }

  return apiInstance.post(`/consent/workflow/toronto_uh/${token}/confirm`, params)
    .then(response => {
      return response
    })
    .catch(error => {
      return Promise.reject(error);
    });
}


const confirmConsentOttawaByToken = (token, params, dateOfBirth='', signature='', witnessSignature='', investigatorSignature='', consentFile='') => {

  if (dateOfBirth !== '') {
    params.dateOfBirth = dateOfBirth;
  }

  if (signature !== '') {
    params.signature = signature;
  }

  if (witnessSignature !== '') {
    params.witnessSignature = witnessSignature;
  }

  if (investigatorSignature !== '') {
    params.investigatorSignature = investigatorSignature;
  }

  return apiInstance.post(`/consent/workflow/ottawa/${token}/confirm`, params)
    .then(response => {
      return response
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

const confirmConsentRoyalByToken = (token, params, dateOfBirth='', signature='', witnessSignature='', investigatorSignature='', consentFile='') => {

  if (dateOfBirth !== '') {
    params.dateOfBirth = dateOfBirth;
  }

  if (signature !== '') {
    params.signature = signature;
  }

  if (witnessSignature !== '') {
    params.witnessSignature = witnessSignature;
  }

  if (investigatorSignature !== '') {
    params.investigatorSignature = investigatorSignature;
  }

  return apiInstance.post(`/consent/workflow/royal/${token}/confirm`, params)
    .then(response => {
      return response
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

const confirmConsentRoyalUniversityByToken = (token, params, dateOfBirth='', signature='', witnessSignature='', investigatorSignature='', consentFile='') => {

  if (dateOfBirth !== '') {
    params.dateOfBirth = dateOfBirth;
  }

  if (signature !== '') {
    params.signature = signature;
  }

  if (witnessSignature !== '') {
    params.witnessSignature = witnessSignature;
  }

  if (investigatorSignature !== '') {
    params.investigatorSignature = investigatorSignature;
  }

  return apiInstance.post(`/consent/workflow/royal_university/${token}/confirm`, params)
    .then(response => {
      return response
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

const confirmConsentWinnipegByToken = (token, params, dateOfBirth='', signature='', witnessSignature='', investigatorSignature='', consentFile='') => {

  if (dateOfBirth !== '') {
    params.dateOfBirth = dateOfBirth;
  }

  if (signature !== '') {
    params.signature = signature;
  }

  if (witnessSignature !== '') {
    params.witnessSignature = witnessSignature;
  }

  if (investigatorSignature !== '') {
    params.investigatorSignature = investigatorSignature;
  }

  return apiInstance.post(`/consent/workflow/winnipeg/${token}/confirm`, params)
    .then(response => {
      return response
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

const confirmConsentUhnByToken = (token, params, dateOfBirth='', signature='', witnessSignature='', investigatorSignature='', consentFile='') => {

  if (dateOfBirth !== '') {
    params.dateOfBirth = dateOfBirth;
  }

  if (signature !== '') {
    params.signature = signature;
  }

  if (witnessSignature !== '') {
    params.witnessSignature = witnessSignature;
  }

  if (investigatorSignature !== '') {
    params.investigatorSignature = investigatorSignature;
  }

  return apiInstance.post(`/consent/workflow/uhn/${token}/confirm`, params)
    .then(response => {
      return response
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

const confirmConsentMontrealByToken = (token, params, dateOfBirth='', signature='', witnessSignature='', investigatorSignature='', consentFile='') => {

  if (dateOfBirth !== '') {
    params.dateOfBirth = dateOfBirth;
  }

  if (signature !== '') {
    params.signature = signature;
  }

  if (witnessSignature !== '') {
    params.witnessSignature = witnessSignature;
  }

  if (investigatorSignature !== '') {
    params.investigatorSignature = investigatorSignature;
  }

  return apiInstance.post(`/consent/workflow/montreal/${token}/confirm`, params)
    .then(response => {
      return response
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

const confirmConsentChusByToken = (token, params, dateOfBirth='', signature='', witnessSignature='', investigatorSignature='', consentFile='') => {

  if (dateOfBirth !== '') {
    params.dateOfBirth = dateOfBirth;
  }

  if (signature !== '') {
    params.signature = signature;
  }

  if (witnessSignature !== '') {
    params.witnessSignature = witnessSignature;
  }

  if (investigatorSignature !== '') {
    params.investigatorSignature = investigatorSignature;
  }

  return apiInstance.post(`/consent/workflow/chus/${token}/confirm`, params)
    .then(response => {
      return response
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

const confirmConsentQuebecChuByToken = (token, params, dateOfBirth='', signature='', witnessSignature='', investigatorSignature='', consentFile='') => {

  if (dateOfBirth !== '') {
    params.dateOfBirth = dateOfBirth;
  }

  if (signature !== '') {
    params.signature = signature;
  }

  if (witnessSignature !== '') {
    params.witnessSignature = witnessSignature;
  }

  if (investigatorSignature !== '') {
    params.investigatorSignature = investigatorSignature;
  }

  return apiInstance.post(`/consent/workflow/quebec_chu/${token}/confirm`, params)
    .then(response => {
      return response
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

const confirmConsentKelownaByToken = (token, params, dateOfBirth='', signature='', witnessSignature='', investigatorSignature='', consentFile='') => {

  if (dateOfBirth !== '') {
    params.dateOfBirth = dateOfBirth;
  }

  if (signature !== '') {
    params.signature = signature;
  }

  if (witnessSignature !== '') {
    params.witnessSignature = witnessSignature;
  }

  if (investigatorSignature !== '') {
    params.investigatorSignature = investigatorSignature;
  }

  return apiInstance.post(`/consent/workflow/kelowna/${token}/confirm`, params)
    .then(response => {
      return response
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

const confirmConsentByTypeAndToken = (workflow_type, token, params) => {
  return apiInstance.post(`/consent/workflow/${workflow_type}/${token}/confirm`, params)
    .then(response => {
      return response
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

const createConsentByUrl = url => (params, consentFile='') => {
    if (consentFile !== '') {
      params.consentFile = consentFile;

      let formData = new FormData();

      Object.keys(params).map((key) => {
        if (params[key] && !['consentFile', 'fileList'].includes(key)){
          formData.append(key, params[key])
        }
      });

      formData.append('consentFile', params.consentFile[0].originFileObj);

      return apiFormInstance.post(url, formData)
        .then(response => {
          return response
        })
        .catch(error => {
          return Promise.reject(error);
        });

    } else {

      return apiInstance.post(url, params)
        .then(response => {
          return response
        })
        .catch(error => {
          return Promise.reject(error);
        });

    }
  }

const getConsentByUrlToken = url => token => apiInstance.get(`${url}${token}`)
  .then(response => {
    return response
  })
  .catch(error => {
    return Promise.reject(error);
  });

const confirmConsentByUrlToken = url => (token, params, dateOfBirth='', signature='', witnessSignature='', investigatorSignature='', consentFile='') => {

  if (dateOfBirth !== '') {
    params.dateOfBirth = dateOfBirth;
  }

  if (signature !== '') {
    params.signature = signature;
  }

  if (witnessSignature !== '') {
    params.witnessSignature = witnessSignature;
  }

  if (investigatorSignature !== '') {
    params.investigatorSignature = investigatorSignature;
  }

  return apiInstance.post(`${url}${token}/confirm`, params)
    .then(response => {
      return response
    })
    .catch(error => {
      return Promise.reject(error);
    });
}


const createConsentWithFileWithdrawByUrl = url => (params, consentFile='', consentFileDc=null, consentFileWithdraw=null) => {
  if (consentFile !== '' || consentFileDc !== null || consentFileWithdraw !== null) {
    params.consentFile = consentFile;
    if (consentFileDc !== null) {
      params.consentFileDc = consentFileDc;
    }
    if ( consentFileWithdraw !== null) {
      params.consentFileWithdraw = consentFileWithdraw;
    }

    let formData = new FormData();

    Object.keys(params).map((key) => {
      if (params[key] && !['consentFile', 'consentFileDc', 'consentFileWithdraw', 'fileList', 'fileListDc', 'fileListWithdraw'].includes(key)){
        formData.append(key, params[key])
      }
    });

    formData.append('consentFile', params.consentFile[0].originFileObj);
    if (consentFileDc !== null) {
      formData.append('consentFileDc', params.consentFileDc[0].originFileObj);
    }
    if ( consentFileWithdraw !== null) {
      formData.append('consentFileWithdraw', params.consentFileWithdraw[0].originFileObj);
    }

    return apiFormInstance.post(url, formData)
      .then(response => {
        return response
      })
      .catch(error => {
        return Promise.reject(error);
      });

  } else {

    return apiInstance.post(url, params)
      .then(response => {
        return response
      })
      .catch(error => {
        return Promise.reject(error);
      });

  }
};

export const consentServices = {
  create,
  createEdmonton,
  createSunnyBrook,
  createTorontoUH,
  createKelowna,
  createMontreal,
  createVancouver,
  createChus,
  createQuebecChu,
  createWinnipeg,
  createUhn,
  createConsentByType,
  getConsentByToken,
  getConsentEdmontonByToken,
  getConsentSunnyBrookByToken,
  getConsentTorontoUHByToken,
  getConsentKelownaByToken,
  getConsentMontrealByToken,
  getConsentVancouverByToken,
  getConsentChusByToken,
  getConsentQuebecChuByToken,
  getConsentWinnipegByToken,
  getConsentUhnByToken,
  getConsentByWorkflowTypeAndToken,
  confirmConsentByToken,
  confirmConsentEdmontonByToken,
  confirmConsentSunnyBrookByToken,
  confirmConsentTorontoUHByToken,
  confirmConsentKelownaByToken,
  confirmConsentMontrealByToken,
  confirmConsentChusByToken,
  confirmConsentQuebecChuByToken,
  confirmConsentWinnipegByToken,
  confirmConsentUhnByToken,
  confirmConsentByTypeAndToken,
  createLhs: createConsentByUrl('/consent/workflow/lhs'),
  getConsentLhsByToken: getConsentByUrlToken('/consent/workflow/lhs/'),
  confirmConsentLhsByToken: confirmConsentByUrlToken('/consent/workflow/lhs/'),

  createGreyNuns,
  getConsentGreyNunsByToken,
  confirmConsentGreyNunsByToken,

  createRedDeer: createCalgaryLikeConsentByUrl('/consent/workflow/red_deer'),
  getConsentRedDeerByToken: getConsentByUrlToken('/consent/workflow/red_deer/'),
  confirmConsentRedDeerByToken: confirmConsentByUrlToken('/consent/workflow/red_deer/'),

  createMedicineHat,
  getConsentMedicineHatByToken,
  confirmConsentMedicineHatByToken,

  createLethbridge: createConsentWithFileWithdrawByUrl('/consent/workflow/lethbridge'),
  getConsentLethbridgeByToken: getConsentByUrlToken('/consent/workflow/lethbridge/'),
  confirmConsentLethbridgeByToken: confirmConsentByUrlToken('/consent/workflow/lethbridge/'),

  createKingston: createConsentByUrl('/consent/workflow/kingston'),
  getConsentKingstonByToken: getConsentByUrlToken('/consent/workflow/kingston/'),
  confirmConsentKingstonByToken: confirmConsentByUrlToken('/consent/workflow/kingston/'),

  createHamilton: createConsentByUrl('/consent/workflow/hamilton'),
  getConsentHamiltonByToken: getConsentByUrlToken('/consent/workflow/hamilton/'),
  confirmConsentHamiltonByToken: confirmConsentByUrlToken('/consent/workflow/hamilton/'),

  createOttawa,
  confirmConsentOttawaByToken,
  getConsentOttawaByToken,

  createRoyalUniversity,
  confirmConsentRoyalUniversityByToken,
  getConsentRoyalUniversityByToken,

  createRoyal,
  confirmConsentRoyalByToken,
  getConsentRoyalByToken,
};



// WEBPACK FOOTER //
// ./src/services/consent.services.js